"use client";
import React from "react";
import { PublicSignupProvider } from "@/components/auth/PublicSignupProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { SessionProvider } from "next-auth/react";
import { Session } from "next-auth";
import { useState } from "react";

function Providers({
  children,
  session,
  publicSignupEnabled = false,
}: {
  children: React.ReactNode;
  session: Session | null;
  publicSignupEnabled?: boolean;
}) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider session={session}>
        <PublicSignupProvider enabled={publicSignupEnabled}>{children}</PublicSignupProvider>
      </SessionProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default Providers;
